import script from "./hpSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./hpSkills.vue?vue&type=script&setup=true&lang=js"

import "./hpSkills.vue?vue&type=style&index=0&id=2377b30c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2377b30c"]])

export default __exports__